import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import SplitScreenContent from "../../components/SplitScreenContent";

export const inspektionWartung = {
  title: "Inspektion & Wartung für Porsche-Modelle",
  titleImageUrl: "neue_bilder/service/werkstatt-innenraum.jpg",
  meta: {
    title:
      "Porsche Inspektion & Wartung – Kleine & Große Inspektion nach Porsche-Standard | WTM Sportwagen",
    description:
      "Inspektion & Wartung für Porsche 911, 964, 993, 996, 997, 991, Boxster, Cayman und Cayenne. Nach Hersteller-Plan, transparente Dokumentation & Eintrag ins digitale Serviceheft. Hol-/Bringservice deutschlandweit.",
  },
  content: [
    {
      type: "hero_image",
      backgroundImage:
        "https://res.cloudinary.com/donwh3eei/image/upload/v1756323400/gallery/frank_kayser/L1013228_yfgfsy.jpg",
      headline: "Inspektion & Wartung nach Porsche-Standard",
      description:
        "Ein Porsche verdient Sorgfalt. Bei WTM prüfen, warten und dokumentieren wir mit derselben Präzision wie beim Motorenbau – ehrlich, gründlich, werterhaltend.",
      hasVignette: true,
      overlayOpacity: 0.01,
    },

    {
      type: "text_section_hero",
      headline: "Schnellsuche für Ihr Porsche-Modell",
      lead: "Finden Sie schnell die Inspektionspreise für Ihr spezifisches Porsche-Modell. Geben Sie einfach die Baureihe oder den Modellnamen ein.",
      spacing: "comfortable_top_tight_bottom",
      size: "md",
      variant: "primary",
    },

    {
      type: "inspection-pricing-search",
      variant: "primary",
      spacing: "none_top_tight_bottom",
      maxWidth: "4xl",
      contentClassName: "mx-auto",
    },

    {
      type: "text_section_hero",
      headline: "Preisübersicht für alle Porsche-Modelle",
      lead: "Unsere Inspektionspreise im Überblick – Alle Preise verstehen sich inklusive Dokumentation und Serviceheft-Eintrag.",
      spacing: "tight_top_none_bottom",
      size: "md",
      variant: "primary",
    },

    {
      type: "inspection-pricing-table",
      variant: "primary",
      spacing: "none_top_comfortable_bottom",
      maxWidth: "4xl",
      contentClassName: "mx-auto",
    },
    {
      type: "cta-with-modal",
      headline: "Termin oder Angebot anfragen",
      paragraph:
        "Sie möchten die nächste Inspektion planen oder zu Modellspezifika beraten werden? Wir melden uns persönlich.",
      darkMode: false,
      spacing: "comfortable",
    },
    {
      type: "split_screen_layout",
      leftImage: "gallery/frank_kayser/M10_6861_v6tonq",
      headline: "Service & Wartung bei WTM",
      rightContent: (
        <SplitScreenContent
          headline="Ihr Porsche in besten Händen"
          intro="Bei WTM Sportwagen verbinden wir jahrelange Erfahrung mit echter Leidenschaft für Porsche. Jede Inspektion wird mit derselben Sorgfalt durchgeführt wie unsere Motorenbauprojekte."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Persönliche Betreuung",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Von der Terminvereinbarung bis zur Fahrzeugübergabe stehen wir persönlich für Sie da. Transparente Kommunikation und ehrliche Beratung sind für uns selbstverständlich.",
            },
            {
              type: "heading",
              text: "Ehrliche Beratung",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Sinnvolle Präventivmaßnahmen statt Teiletausch auf Verdacht – wir empfehlen nur was wirklich nötig ist und erklären Ihnen transparent jeden Arbeitsschritt.",
            },
            {
              type: "heading",
              text: "Digitale Dokumentation",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Jede Inspektion wird lückenlos dokumentiert. Bei modernen Modellen übernehmen wir den Eintrag ins digitale Serviceheft – für nachhaltigen Werterhalt.",
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Service - Porsche Inspektion",
      navbarHeight: 0,
    },

    // {
    //   type: "paragraph",
    //   text: "Ob <strong>kleine oder große Inspektion</strong>: Wir arbeiten strikt nach dem Porsche-Wartungsplan, verwenden hochwertige Teile und halten jede Position transparent fest. Bei modernen Modellen übernehmen wir die <strong>Eintragung ins digitale Serviceheft</strong> – für lückenlose Historie und nachhaltigen Werterhalt.",
    // },

    // {
    //   type: "icon-bullet-list",
    //   headline: "Warum Inspektion bei WTM Sportwagen?",
    //   icon: faCheckCircle,
    //   items: [
    //     "Service nach Hersteller-Vorgaben – sauber dokumentiert mit Fotos & Protokoll",
    //     "Ehrliche Beratung: sinnvolle Präventivmaßnahmen statt Teiletausch auf Verdacht",
    //     "Luft- & wassergekühlte Expertise: 911 (F/G), 964, 993, 996, 997, 991 sowie Boxster & Cayman",
    //     "Digitales Serviceheft (z. B. 997, 991, Boxster, Cayman) – Eintrag inklusive",

    //     // "Versicherter Hol- & Bringservice deutschlandweit",
    //   ],
    //   highlightedIndices: [0, 1],
    //   spacing: "comfortable",
    // },

    {
      type: "split_screen_layout",
      leftImage: "gallery/frank_kayser/M10_7614_mm2syw",
      headline: "Inspektion im Detail",
      rightContent: (
        <SplitScreenContent
          headline="Kleine vs. große Inspektion"
          intro="Bei Porsche gibt es offiziell nur Wartungsintervalle – die Unterscheidung in ‚klein‘ und ‚groß‘ ist eine Vereinfachung. Der tatsächliche Umfang hängt immer vom Modell, der Laufleistung und dem Zustand des Fahrzeugs ab."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Was gehört dazu?",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Kleine Inspektion bedeutet meist Öl- und Filterwechsel sowie Basischecks. Eine große Inspektion ergänzt diese Arbeiten um zusätzliche Punkte wie Zündkerzen, Bremsflüssigkeit, PDK-/Getriebeöl oder Ventilspielkontrolle – je nach Modell und Laufleistung unterschiedlich.",
            },
            {
              type: "heading",
              text: "Warum die Preise variieren",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Ein klassischer 911 benötigt z. B. deutlich mehr Zeit fürs Ventile einstellen als ein moderner 991, bei dem andere Baugruppen im Fokus stehen. Auch die Ölmenge, die Ölqualität und die Zugänglichkeit einzelner Bauteile unterscheiden sich stark. Deshalb sind die Inspektionskosten modellabhängig und können variieren.",
            },
            {
              type: "heading",
              text: "Sinnvolle Zusatzservices",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Zusätzlich zu den regulären Inspektionspunkten bieten wir Services an, die besonders für sportlich genutzte oder selten bewegte Fahrzeuge relevant sind:",
              style: { marginBottom: "-100px !important" },
            },
            {
              type: "list",
              items: [
                "Pflege und Wartung des Verdecks (bei Cabrio-Modellen)",
                "Aufbereitung von Leder, Kunststoff und Innenraum",
                "Reinigung und Konservierung des Motorraums",
                "Klimaservice inkl. Dichtigkeitsprüfung",
                "Lackaufbereitung oder kleine Lackkorrekturen",
                "Austausch von Bremsbelägen und Bremsscheiben",
                "PDK/Tiptronic-Ölservice (modellabhängig)",
                "Austausch von Keil- oder Zahnriemen inklusive Spannrollen",
                "Wechsel von Fahrwerkskomponenten wie Dämpfer, Querlenker oder Lager",
                "Kraftstoff-/Ansaug-Pflege für selten bewegte Fahrzeuge",
                "Track-Pre-Check: Drehmomente, Beläge, Reifen, Flüssigkeiten",
              ],
            },
            {
              type: "heading",
              text: "Diese Porsche-Modelle betreuen wir regelmäßig",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Von Klassikern bis modernen GT-Modellen: Wir kennen die Eigenheiten und Wartungsbedarfe jeder Baureihe.",
            },
            {
              type: "list",
              items: [
                "Luftgekühlt: 911 F- & G-Modell, 964, 993",
                "Wassergekühlt: 996, 997, 991 (Carrera, Turbo, GT-Modelle)",
                "Boxster & Cayman: 986, 987, 981",
                "Transaxle: 944, 968, 928, 924",
                "SUV & Limousine: Cayenne, Macan, Panamera",
              ],
            },
            {
              type: "component",
              component: "CallToActionWithModalV2",
              props: {
                headline: "Termin oder Angebot anfragen",
                paragraph:
                  "Sie möchten Ihr Fahrzeug betreuen lassen? Wir melden uns persönlich und beraten Sie zu allen Fragen rund um Service und Wartung.",
                darkMode: false,
                margin: false,
              },
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Inspektion - Porsche Service Details",
      navbarHeight: 0,
    },

    // {
    //   type: "highlighted-paragraph",
    //   text: "Sammlerfahrzeug mit niedriger Laufleistung oder sportlich genutztes Tracktool – wir warten jedes Auto mit demselben Anspruch: <strong>verlässlich, wertstabil, fahrbereit</strong>.",
    //   style: {
    //     marginTop: "-40px",
    //   },
    // },

    {
      type: "relevant-posts",
      postSlugs: [
        "porsche-inspektion-haeufigste-verschleissteile",
        "porsche-luftgekuehlte-inspektion-vs-serviceheft",
        "porsche-elektronik-sensoren-fehlerquellen",
      ],
      headline: "Werkstatt Journal: Wartung & Werterhalt bei Porsche",
      introText:
        "Alles zum Thema Porsche Inspektion, Wartung und Werterhalt in unserem Werkstatt Journal.",
      darkMode: false,
    },
  ],
};
